export default "__VITE_ASSET__BHTZyWNb__"